<template>
  <div>
    <div class="fff">
      <div v-for="(item, index) in SelectList" :key="index">
        <!-- <div v-if="item.category == 'LAB'"> -->
        <div class="inline">
          <el-divider direction="vertical"></el-divider>

          <h3 class="Xjiao">{{ item.title }}</h3>
        </div>
        <div v-html="item.explain"></div>
        <!-- <el-image class="img" :src="item.cover" alt=""></el-image> -->
      </div>
      <!-- </div> -->

      <div class="inline">
        <el-divider direction="vertical"></el-divider>
        <h3 class="Xjiao">{{ $t("menu.ServicesAvailable") }}</h3>
      </div>

      <el-row :gutter="10">
        <div v-for="(itemq, indexq) in listE" :key="indexq">
          <el-col :span="12">
            <div class="back">
              <el-image class="cover" :src="itemq.cover"></el-image>
              <h4 class="XiaoJiao">{{ itemq.title }}</h4>

              <div>
                <p
                  class="hideen"
                  style="margin: 0px 10px"
                  v-html="itemq.explain"
                ></p>
              </div>

              <el-col :span="6" :offset="9">
                <router-link :to="itemq.routePath">
                  <el-button size="mini" class="details" round>{{
                    $t("menu.particulars")
                  }}</el-button>
                </router-link>
              </el-col>
            </div>
          </el-col>
        </div>
      </el-row>
      <!-- 荣誉资质 -->
      <el-row :gutter="10">
        <div class="inline" style="margin-top: 10px">
          <el-divider direction="vertical"></el-divider>
          <h3 class="Xjiao">{{ $t("menu.RongYu") }}</h3>
        </div>
        <div
          v-for="(itemcertificates, indexcertificates) in certificates"
          :key="indexcertificates" >
          <el-col :span="12">
            <div class="backTwo">
              <el-image
                style="width: 207px; height: 281px"
                :src="itemcertificates.coverImage"
                @click="openPdf(itemcertificates.filePath)"
              ></el-image>
              <!-- </button> -->
              <div
                style="border-bottom: 1px solid #cccccc; margin: 20px 0px"
              ></div>
              <h4 class="CMAzhen"  @click="openPdf(itemcertificates.filePath)">{{ certiTitle }}</h4>
            </div>
          </el-col>
        </div>
      </el-row>

      <!-- 实验室照片 -->

      <el-row :gutter="10">
        <div class="inline" style="margin-top: 10px">
          <el-divider direction="vertical"></el-divider>
          <h3 class="Xjiao">{{ $t("menu.LaboratoryPhotograph") }}</h3>
        </div>
        <div v-for="(itemSan, indexsan) in ShiYanList" :key="indexsan">
          <el-col :span="12">
           
            <el-image
              style="width: 100%; height: 310px"
              :src="itemSan.pictureUrl"
            ></el-image>
          </el-col>
        </div>
      </el-row>

      <!-- 实验室设备 -->

      <el-row :gutter="10">
        <div class="inline">
          <el-divider direction="vertical"></el-divider>
          <h3 class="Xjiao">{{ $t("menu.laboratoryEquipment") }}</h3>
        </div>
        <div v-for="(itemsi, indexsi) in EquipmentList" :key="indexsi">
          <el-col :span="12">
            <el-image
              style="width: 100%; height: 310px"
              :src="itemsi.pictureUrl"
            ></el-image>
          </el-col>
        </div>
      </el-row>
    </div>
  </div>
</template>

<style lang="less" scoped>
.el-divider--vertical {
  margin-left: 0px;
}
.hideen {
  margin: 0px 10px;
  width: 360px;
  height: 86px;
  overflow: hidden; /*文字超出时隐藏*/
  text-overflow: ellipsis; /*文本溢出时，显示省略符号*/
  word-break: break-all; /*英文自动换行*/

  /*webkit私有属性，仅支持webkit核*/
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4; /*显示行数*/

  /*根据行高来限制高度*/
  // line-height: 1.5;
  // height: 4.5em; /*高度等于行高的3倍*/

  // position: relative; /*配合 .text:after 定位使用*/
}
.hideen /deep/p {
  margin: 0px 10px !important;
}
.fff {
  background: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
  padding-top: 0px;
}
.img {
  width: 100%;
  height: 565px;
}

.back {
  width: 100%;
  height: 240px;
  background: #f2f2f2;
  margin-bottom: 10px;
  text-align: center;
  padding: 30px 0px;
}
.CMAzhen:hover {
  color: #1d2088;
}
.backTwo {
  width: 100%;
  height: 371px;
  background: #f2f2f2;
  margin-bottom: 10px;
  text-align: center;
  padding-top: 20px;
}

h3 {
  font-size: 20px;

  // font-weight: 400;
  /* color: #333333; */
}
p {
  color: #666666;
  font-size: 16px;
  margin-top: 0px;
}
span {
  font-size: 12px;
  color: #999999;
}

.XiaoJiao {
  font-size: 20px;
  margin: 15px 0px;
}
</style>


<script>
// import pdf from "vue-pdf";

export default {
  name: "LaboratoryRight",
  // components: {
  //   pdf,
  // },
  data() {
    return {
      SelectList: [],
      listE: [],
      ShiYanList: [],
      EquipmentList: [],
      certificates: [],
      certiTitle: "",
	  title:'',
    };
  },
  created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }

    this.getSelect();
  },

  methods: {
    async getSelect() {
      //橡胶
      const { data: resER } = await this.$http.get("/Team/GetLabInfo", {
        params: { languageType: this.title },
      });

      if (resER.code !== 200) return console.log("数据请求失败! ");
      // 文字

      this.SelectList = resER.data.brief.filter((t) => t.category == "LAB");
      this.listE = resER.data.brief.filter((t) => t.category == "Business");
      this.ShiYanList = resER.data.picture.filter(
        (t) => t.category == "environment"
      );
      this.EquipmentList = resER.data.picture.filter(
        (t) => t.category == "equipment"
      );
      this.certificates = resER.data.certificates;
      // console.log(this.certificates);
      for (let index = 0; index < this.certificates.length; index++) {
        if (this.$i18n.locale == "TC") {
          this.certiTitle = this.certificates[index].titleTC;
        } else if (this.$i18n.locale == "EN") {
          this.certiTitle = this.certificates[index].titleEN;
        } else if (this.$i18n.locale == "SC") {
          this.certiTitle = this.certificates[index].titleSC;
        }
      }

    
    },
    openPdf(filePath){
    let op = this.$router.resolve({
        name: "PdfView",
        query: {'pdfFile':filePath}
      })
      window.open(op.href,'_blank')
    }
  },
};
</script>